{
  "primer": {
    "eyebrow": "Oraret e namazit dhe Kibla",
    "headline": "Rhemn ka nevojë për vendndodhjen tënde për oraret e namazit dhe Kiblën.",
    "body": "E përdorim vetëm për oraret e namazit, drejtimin e Kiblës dhe motin vendas — asgjë tjetër.",
    "cta": "Vazhdo",
    "skip": "Jo tani",
    "skip_body": "Oraret e namazit dhe Kibla do të mbeten të fikura."
  }
}
